/**
 * Абсолютизирует относительную ссылку на фото по хосту клиента (VUE_APP_CLIENT_URL).
 * Абсолютные ссылки (http(s)://, //) и data:-URI возвращаются без изменений,
 * поэтому фото на любых хостах (mn1/mn0 и т.п.) не переписываются.
 */
export function resolvePhotoUrl(link?: string | null): string {
    if (!link) {
        return '';
    }
    if (link.startsWith('data:')) {
        return link;
    }
    if (/^(https?:)?\/\//i.test(link)) {
        return link;
    }
    const base = (process.env.VUE_APP_CLIENT_URL || '').replace(/\/+$/, '');
    if (!base) {
        return link;
    }
    return `${base}/${link.replace(/^\/+/, '')}`;
}

/**
 * Строит ссылку на клиентский хост из подпути, нормализуя базу VUE_APP_CLIENT_URL:
 * срезает хвостовой слэш базы и ведущие слэши подпути, чтобы при базе '/'
 * не возникал протокол-относительный '//path' (браузер трактует его как хост).
 * Примеры: база '/' + 'project/1' -> '/project/1'; база 'https://host' -> 'https://host/project/1'.
 */
export function buildClientUrl(subPath: string): string {
    const base = (process.env.VUE_APP_CLIENT_URL || '').replace(/\/+$/, '');
    return `${base}/${(subPath || '').replace(/^\/+/, '')}`;
}

export function normalizeUrlForOpening(url: string, forceHttps: boolean = true): string {
    const clearUrl = url.trim();

    if (/^(https?|ftp):\/\//i.test(clearUrl)) {
        return clearUrl;
    }

    if (/^www\./i.test(clearUrl)) {
        const protocol = forceHttps ? 'https://' : 'http://';
        return protocol + clearUrl;
    }

    if (clearUrl.includes('.') && !clearUrl.includes(' ')) {
        const protocol = forceHttps ? 'https://' : 'http://';
        return protocol + clearUrl;
    }

    return clearUrl;
}
